<template>
  <v-container class="pt-0 pb-0">
    <v-select
      :disabled="disabled"
      v-model="localSelected"
      :items="filteredSectors"
      item-text="Name"
      item-value="Id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="true"
      :chips="true"
      :small-chips="true"
      :hide-details="true"
      :label="label"
      deletable-chips
      multiple
    >
      <template v-slot:prepend-item>
        <v-text-field
          class="pl-5 pr-5"
          label="Search"
          v-model="search"
        ></v-text-field>
      </template>
    </v-select>
  </v-container>
</template>

<script>
const EMITTED_ACTIONS = {
  CHANGE: "change",
};

import SECTORS from "@/common/constants/controlRisks/sectors.js";

export default {
  name: "IncidentsSectorSelector",
  props: {
    selected: {
      type: Array,
    },
    disabled: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    reset: {
      type: String,
    },
  },
  data() {
    return {
      search: "",
      sectors: SECTORS,
      localSelected: [],
    };
  },
  computed: {
    filteredSectors() {
      return this.sectors
        .filter((item) => {
          return (
            item.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
            this.search === ""
          );
        })
        .sort(function (a, b) {
          var nameA = a.Name.toLowerCase();
          var nameB = b.Name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
    },
  },
  mounted() {
    this.handleCheckboxChange();
  },
  methods: {
    handleCheckboxChange() {
      if (this.selected) {
        this.localSelected = this.selected;
      } else {
        this.localSelected = null;
      }
    },
  },
  watch: {
    selected: {
      handler() {
        this.handleCheckboxChange();
      },
    },
    localSelected: {
      handler() {
        this.$emit(EMITTED_ACTIONS.CHANGE, this.localSelected);
      },
    },
    reset: {
      handler() {
        this.handleCheckboxChange();
      },
    },
  },
};
</script>

<style scoped></style>
